const ageModal = document.querySelector('.agree_btn');

if (window.location.href == 'https://raicesibericas.com/?code=en') {
  const imageENG = document.querySelectorAll('.flip-card-front .image')[4];
  const imageENG2 = document.querySelectorAll('.flip-card-front .image')[5];
  imageENG.src =
    'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/3_6dfb6356-e156-4e66-8ab3-446ea9e9f8a4.png?v=1661373557';
  imageENG2.src =
    'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/3_6dfb6356-e156-4e66-8ab3-446ea9e9f8a4.png?v=1661373557';
}

const imageArray = [
  'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/mapa-RAICES-nuestrosproyectos_nuevo_alta_29_marzo_2023.jpg?v=1680534574',
  'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/mapa-LASPIZARRAS-nuestrosproyectos-min.jpg?v=1666958348',
  'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/mapa-CARLOSRUBEN-nuestrosproyectos_ajustado-min.jpg?v=1666958347',
  'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/mapa-RAMITO-nuestrosproyectos-min.jpg?v=1666958348',
];
const imageMap = document.getElementById('image-map');

let buttons = document.getElementsByClassName('btn-ver-mapa');

let modal = document.getElementById('myModal_apolo');

let buttonModal = document.getElementById('myBtn_sub');

let span = document.getElementById('close_apolo');

let arr = Array.from(buttons);

arr.forEach(btn => {
  btn.addEventListener('click', e => {
    const index = Array.from(arr).indexOf(e.target);

    imageMap.src = imageArray[index];
    modal.style.display = 'block';
    span.onclick = function () {
      modal.style.display = 'none';
    };

    span.addEventListener('click', function () {
      modal.style.display = 'none';
    });

    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = 'none';
      }
    };
  });
});
